import React from "react";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { Page, PageTitle } from "@ui/Page";
import { FormattedMessage } from "react-intl";

function NotFoundPage(): JSX.Element {
    return (
        <Page>
            <PageTitle className="display-1" tag="h1">
                <FormattedMessage {...messages.notFoundTitle} />
            </PageTitle>
            <p className="sub-heading">
                <FormattedMessage {...messages.notFoundDescription} />
            </p>
        </Page>
    );
}

const NotFoundPageSetTitle = setTitleOnPage(messages.pageNotFoundTitle)(NotFoundPage);

export { NotFoundPageSetTitle as NotFoundPage };
